import { Flooding } from 'features/flooding/flooding.types';
import { GeoEventSlackChannels } from 'features/geoEvents/components/GeoEventSlackChannels';
import { InternalLinksList } from 'features/geoEvents/components/InternalLinksList';
import { Urgency } from 'features/geoEvents/components/Urgency';
import { Location } from 'features/locations/location.types';
import { ReporterNotesList } from 'features/reporterNotes/components/ReporterNotesList';
import { Wildfire } from 'features/wildfires/wildfire.types';

type InternalIncidentInfoProps = {
  geoEvent: Wildfire | Flooding | Location | undefined;
};

export const InternalIncidentInfo = (
  props: InternalIncidentInfoProps,
): JSX.Element => {
  const { geoEvent } = props;

  return (
    <>
      <GeoEventSlackChannels geoEventId={geoEvent?.id} />
      <Urgency geoEvent={geoEvent} />
      <ReporterNotesList geoEventId={geoEvent?.id} />
      <InternalLinksList geoEvent={geoEvent} />
    </>
  );
};
